* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
}

gz-basic-table::part(column-0) {
  flex: 0 0 auto;
}

gz-basic-table::part(column-1) {
  align-items: start;
  min-width: 130px;
}

.gauge-description-text {
  max-width: 400px;

  &.disabled {
    visibility: hidden;
  }
}

.score-breakdown-wrapper {
  flex: 1;
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;

  gz-basic-table {
    &::part(row) {
      border-bottom: none;
    }

    &::part(legend-square),
    &::part(space-square) {
      width: 10px;
      height: 10px;
    }
  }
}

.risk-distribution-wrapper {
  gz-basic-table {
    &::part(row-label-text) {
      min-width: 120px;
    }
    &::part(column-2) {
      flex: 0.1;
    }
  }
}

.loading-state-wrapper {
  & > div {
    flex: 1;
  }
}
